import { prepareAvatar } from './prepareAvatar';
import { prepareTitle } from './prepareTitle';
import { prepareProfileLink } from './prepareProfileLink';
import { prepareLabels } from './prepareLabels';
import { prepareQualityInfo } from './prepareQualityInfo';
import { prepareName } from './prepareName';
import { IOfferCard } from '../../../../types';
import { prepareMoreOffersLink } from './prepareMoreOffersLink';
import { prepareBookButton } from './prepareBookButton';

export const preparePublisher = (offerCard: IOfferCard) => ({
  title: prepareTitle(offerCard),
  name: prepareName(offerCard),
  avatar: prepareAvatar(offerCard),
  profileLink: prepareProfileLink(offerCard),
  brandingLevel: offerCard.brandingLevel,
  labels: prepareLabels(offerCard),
  qualityInfo: prepareQualityInfo(offerCard),
  moreOffersLink: prepareMoreOffersLink(offerCard),
  bookButton: prepareBookButton(offerCard),
});
